import { faUser } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import {
  Box, ListItem, Text, UserProfileImage,
} from '@domain-group/suit-theme'

import { AgentsAndMembers } from '@functions/campaign'

import useTeamMember from '@hooks/useTeamMember'

interface AgentListItemProps {
  hideLeftBorder?: boolean,
  member: AgentsAndMembers,
  userImage: string,
}

const AgentListItem = (props: AgentListItemProps) => {
  const { member, hideLeftBorder, userImage } = props

  const { user } = useTeamMember(member)

  return (
    <ListItem
      boxProps={{
        alignItems: 'center',
        backgroundColor: 'white',
        borderBottom: 'none',
        marginY: 'medium',
        marginLeft: 'small',
        marginRight: 'medium',
        width: '100%',
      }}
      disableHover
    >
      <Box
        borderLeft={hideLeftBorder ? 'none' : '1px solid #ececec'}
        height="40px"
        width="1px"
        marginRight="large"
      />

      <UserProfileImage imageUrl={userImage} height={40} width={40}>
        <FontAwesomeIcon icon={faUser} />
      </UserProfileImage>

      <Box alignItems="center">
        <Text
          fontSize="small"
          marginX="large"
          width="fitContent"
        // @ts-expect-error TS2339
        >{user.full_name}
        </Text>
      </Box>
    </ListItem>
  )
}

export default AgentListItem
